import { useState } from "react";
import moment from "moment";
import Select from "react-select";
import { ReactSVG } from "react-svg";
import exporticon from "../../../assets/images/export-icon.svg";
import TelerikReporting from "../../../components/TelerikReporting/TelerikReporting";
import useReports from "../../../Hooks/useReports";
import Loading from "../../../components/LoadingPage/Loading";
// import ReportHeader from "../../../components/reportHeader/ReportHeader";

const providerStatusList = [
  { value: null, label: "All" },
  { value: true, label: "Active" },
  { value: false, label: "Inactive" },
];

const ProvidersList = () => {
  const [reportKey, setReportKey] = useState(0);
  const [isActive, setIsActive] = useState(providerStatusList[1]);
  const { providerListExportAPI, providerListExportLoading } = useReports();

  const handleStatusChange = (option: any) => {
    setIsActive(option);
    setReportKey(prev => prev + 1);
  };

  const handleProvidersListExport = async () => {
    try {
      const response = await providerListExportAPI({ isActive: isActive.value });
      if (!response) return;

      const blobUrl = URL.createObjectURL(response);
      const fileName = `${localStorage.getItem("profileClientId")?.toUpperCase() ?? "SRX"}_Providers_List_${moment().format("YYYYMMDD_HHmmss")}.xlsx`;

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Provider List Export Failed:", error);
    }
  };

  return (
    <div className="report-content-wrapper">
      {/* <ReportHeader reportTitle="SRX Report - List of Providers" /> */}

      <div className="report-filter-wrapper">
        <div className="report-filter-item-wrapper">
          {providerListExportLoading && <Loading />}

          <div className="filter-item-box">
            <label className="form-label">Status</label>
            <Select
              classNamePrefix="react-select"
              options={providerStatusList}
              value={isActive}
              onChange={handleStatusChange}
              placeholder="Select Status"
              isDisabled={providerListExportLoading}
            />
          </div>
        </div>

        <div className="report-export-box">
          <button
            type="button"
            className="report-export-btn"
            onClick={handleProvidersListExport}
            disabled={providerListExportLoading}
          >
            <ReactSVG className="svg-box" wrapper="span" src={exporticon} /> Export
          </button>
        </div>
      </div>

      <div className="filter-detail-wrapper">
        <div className="filter-item-detail-wrapper">
          <div className="providerlist-report-wrapper">
            <TelerikReporting
              key={reportKey}
              params={{
                isActive: isActive.value,
                isExport: false,
              }}
              reportName="ListOfProvidersReport.trdp"
              reportEndPoint="reports/listofproviders/get"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProvidersList;